"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UINavList = _interopRequireDefault(require("./UINavList"));

var UIFolderNav = _react.default.createClass({
  displayName: "UIFolderNav",
  propTypes: (0, _extends2.default)({}, _UINavList.default.propTypes),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UINavList.default.defaultProps);
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className"]);
    return _react.default.createElement(_UINavList.default, (0, _extends2.default)({}, rest, {
      className: (0, _classNames.default)(className, 'private-folder-nav'),
      _rootComponent: UIFolderNav
    }), children);
  }
});

var _default = UIFolderNav;
exports.default = _default;
module.exports = exports.default;